// extracted by mini-css-extract-plugin
export var gif = "_jt-0";